'use client'

import React, { useRef, useState } from 'react'

const Collapse = ({ header, children }) => {
    const [isOpen, setIsOpen] = useState(false)
    const contentRef = useRef(null)

    const handleToggle = () => {
        setIsOpen(prev => !prev)
    }

    return (
        <div
            id={header}
            className="flex flex-col border-t border-[#6670854D] py-10 xs:py-5"
        >
            <div className="flex gap-3 pr-1 justify-between items-center cursor-pointer" onClick={handleToggle}>
                <h2 className="text-header text-[20px] xs:text-[16px] leading-[22px] font-bold">
                    {header}
                </h2>
                <div className="p-2 py-[12px] rounded-full transition-all duration-500 hover:bg-[#dbdbdb] cursor-pointer">
                    <div className={`transition-all duration-[500ms] ${isOpen ? 'rotate-180' : 'rotate-0'}`}>
                        <svg width="15" height="8" viewBox="0 0 15 8" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8.00189 7.50154C8.23548 7.502 8.46185 7.42062 8.64172 7.27154L14.6402 2.27154C14.8443 2.1018 14.9727 1.85789 14.9971 1.59346C15.0215 1.32904 14.9398 1.06576 14.7701 0.86154C14.6861 0.760423 14.583 0.676849 14.4667 0.615591C14.3504 0.554333 14.2231 0.516591 14.0922 0.504519C13.8279 0.48014 13.5647 0.561801 13.3605 0.73154L8.00189 5.21154L2.64329 0.89154C2.54102 0.808474 2.42336 0.746443 2.29705 0.709011C2.17075 0.671579 2.03829 0.659485 1.9073 0.673425C1.7763 0.687364 1.64935 0.727061 1.53375 0.790235C1.41814 0.853409 1.31616 0.938814 1.23365 1.04154C1.1421 1.14436 1.07276 1.26499 1.02998 1.39586C0.987194 1.52673 0.971894 1.66504 0.985034 1.8021C0.998173 1.93916 1.03947 2.07203 1.10634 2.19239C1.1732 2.31275 1.2642 2.418 1.37362 2.50154L7.37205 7.33154C7.55709 7.45706 7.77884 7.51691 8.00189 7.50154Z"
                                fill="#6B7280" />
                        </svg>
                    </div>
                </div>
            </div>
            <div
                ref={contentRef}
                className="flex flex-col gap-5 transition-all duration-500 overflow-hidden"
                style={{
                    height: isOpen ? `${contentRef.current?.scrollHeight}px` : '0',
                    marginTop: isOpen ? '25px' : '0',
                }}
            >
                {children}
            </div>
        </div>
    )
}

export default Collapse
